import { ui } from "@/components/ui";
import { buttonVariants } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { services as s } from "@/services";
import ShareDiaryDialog from "@/features/shared_attributes/components/ShareDiaryDialog";
import { cn } from "@/lib/utils";
import type { StatefulDiaryT } from "@/types/database/diaries";
import {  Syringe, Users2 } from "lucide-react";
import { Route as NewInterventionRoute } from "@/routes/_app/new/diary/$diaryId/events/$eventId";
import { Link } from '@tanstack/react-router';
interface Props {
	diary: StatefulDiaryT;
}
const MoreDropdown = ({ diary }: Props) => {
	// const { navigateAndPrint } = useNavigateAndPrint();

	// const handlePrint = () => {
	// 	console.log("handlePrint");
	// 	navigateAndPrint({
	// 		to: PreviewDiaryRoute.to,
	// 		params: { diaryId: diary.diary_id, patientId: diary.patient_id },
	// 		search: {},
	// 	});
	// };

	return (
		<ui.Dialog>
			<DropdownMenu>
				<DropdownMenuTrigger
					className={cn(buttonVariants({ size: "sm", variant: "secondary" }))}
				>
					More
				</DropdownMenuTrigger>
				<DropdownMenuContent className="min-w-sm" align="start">
					<DropdownMenuLabel>More Options</DropdownMenuLabel>
					<DropdownMenuSeparator />
					<DropdownMenuItem asChild className="flex gap-2 text-md">
						<Link
							to={NewInterventionRoute.to}
							params={{
								diaryId: diary.diary_id,
								eventId: s.uuidv4(),
							}}
						>
							<Syringe size={24} strokeWidth={1.5} />
							<span>New Intervention</span>
						</Link>
					</DropdownMenuItem>
					<ui.DialogTrigger asChild>
						<DropdownMenuItem className="flex gap-2 text-md">
							<Users2 size={24} strokeWidth={1.5} />
							<span>Share</span>
						</DropdownMenuItem>
					</ui.DialogTrigger>
					{/* <DropdownMenuItem
						onClick={handlePrint}
						className="flex gap-2 text-md"
					>
						<Printer size={24} strokeWidth={1.5} />
						<span>Print</span>
					</DropdownMenuItem> */}
				</DropdownMenuContent>
			</DropdownMenu>
			<ShareDiaryDialog diary={diary} />
		</ui.Dialog>
	);
};

export default MoreDropdown;
